/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
	'Type something': 'Napisz coś',
	Advanced: 'Zaawansowane',
	'About Jodit': 'O Jodit',
	'Jodit Editor': 'Edytor Jodit',
	"Jodit User's Guide": 'Instrukcja Jodit',
	'contains detailed help for using':
		'zawiera szczegółowe informacje dotyczące użytkowania.',
	'For information about the license, please go to our website:':
		'Odwiedź naszą stronę, aby uzyskać więcej informacji na temat licencji:',
	'Buy full version': 'Zakup pełnej wersji',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. Wszystkie prawa zastrzeżone.',
	Anchor: 'Kotwica',
	'Open in new tab': 'Otwórz w nowej zakładce',
	'Open in fullsize': 'Otwórz edytor w pełnym rozmiarze',
	'Clear Formatting': 'Wyczyść formatowanie',
	'Fill color or set the text color':
		'Kolor wypełnienia lub ustaw kolor tekstu',
	Redo: 'Ponów',
	Undo: 'Cofnij',
	Bold: 'Pogrubienie',
	Italic: 'Kursywa',
	'Insert Unordered List': 'Wstaw listę wypunktowaną',
	'Insert Ordered List': 'Wstaw listę numeryczną',
	'Align Center': 'Wyśrodkuj',
	'Align Justify': 'Wyjustuj',
	'Align Left': 'Wyrównaj do lewej',
	'Align Right': 'Wyrównaj do prawej',
	'Insert Horizontal Line': 'Wstaw linię poziomą',
	'Insert Image': 'Wstaw grafikę',
	'Insert file': 'Wstaw plik',
	'Insert youtube/vimeo video': 'Wstaw film Youtube/vimeo',
	'Insert link': 'Wstaw link',
	'Font size': 'Rozmiar tekstu',
	'Font family': 'Krój czcionki',
	'Insert format block': 'Wstaw formatowanie',
	Normal: 'Normalne',
	'Heading 1': 'Nagłówek 1',
	'Heading 2': 'Nagłówek 2',
	'Heading 3': 'Nagłówek 3',
	'Heading 4': 'Nagłówek 4',
	Quote: 'Cytat',
	Code: 'Kod',
	Insert: 'Wstaw',
	'Insert table': 'Wstaw tabelę',
	'Decrease Indent': 'Zmniejsz wcięcie',
	'Increase Indent': 'Zwiększ wcięcie',
	'Select Special Character': 'Wybierz znak specjalny',
	'Insert Special Character': 'Wstaw znak specjalny',
	'Paint format': 'Malarz formatów',
	'Change mode': 'Zmień tryb',
	Margins: 'Marginesy',
	top: 'Górny',
	right: 'Prawy',
	bottom: 'Dolny',
	left: 'Levy',
	Styles: 'Style CSS',
	Classes: 'Klasy CSS',
	Align: 'Wyrównanie',
	Right: 'Prawa',
	Center: 'środek',
	Left: 'Lewa',
	'--Not Set--': 'brak',
	Src: 'Źródło',
	Title: 'Tytuł',
	Alternative: 'Tekst alternatywny',
	Link: 'Link',
	'Open link in new tab': 'Otwórz w nowej zakładce',
	Image: 'Grafika',
	file: 'Plik',
	'Image properties': 'Właściwości grafiki',
	Cancel: 'Anuluj',
	Ok: 'OK',
	'Your code is similar to HTML. Keep as HTML?':
		'Twój kod wygląda jak HTML. Zachować HTML?',
	'Paste as HTML': 'Wkleić jako HTML?',
	Keep: 'Oryginalny tekst',
	Clean: 'Wyczyść',
	'Insert as Text': 'Wstaw jako tekst',
	'Word Paste Detected': 'Wykryto tekst w formacie Word',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'Wklejany tekst pochodzi z dokumentu Microsoft Word/Excel. Chcesz zachować ten format czy wyczyścić go? ',
	'Insert only Text': 'Wstaw tylko treść',
	'File Browser': 'Przeglądarka plików',
	'Error on load list': 'Błąd ładowania listy plików',
	'Error on load folders': 'Błąd ładowania folderów',
	'Are you sure?': 'Czy jesteś pewien?',
	'Enter Directory name': 'Wprowadź nazwę folderu',
	'Create directory': 'Utwórz folder',
	'type name': 'wprowadź nazwę',
	'Drop image': 'Upuść plik graficzny',
	'Drop file': 'Upuść plik',
	'or click': 'lub kliknij tu',
	'Alternative text': 'Tekst alternatywny',
	Browse: 'Przeglądaj',
	Upload: 'Wczytaj',
	Background: 'Tło',
	Text: 'Treść',
	Top: 'Góra',
	Middle: 'Środek',
	Bottom: 'Dół',
	'Insert column before': 'Wstaw kolumnę przed',
	'Insert column after': 'Wstaw kolumnę po',
	'Insert row above': 'Wstaw wiersz przed',
	'Insert row below': 'Wstaw wiersz po',
	'Delete table': 'Usuń tabelę',
	'Delete row': 'Usuń wiersz',
	'Delete column': 'Usuń kolumnę',
	'Empty cell': 'Wyczyść komórkę',
	Delete: 'Usuń',
	'Strike through': 'Przekreślenie',
	Underline: 'Podkreślenie',
	Break: 'Przerwa',
	'Search for': 'Szukaj',
	'Replace with': 'Zamień na',
	Replace: 'Wymienić',
	Edit: 'Edytuj',
	'Vertical align': 'Wyrównywanie w pionie',
	'Horizontal align': 'Wyrównywanie w poziomie',
	Filter: 'Filtruj',
	'Sort by changed': 'Sortuj wg zmiany',
	'Sort by name': 'Sortuj wg nazwy',
	'Sort by size': 'Sortuj wg rozmiaru',
	'Add folder': 'Dodaj folder',
	'Split vertical': 'Podziel w pionie',
	'Split horizontal': 'Podziel w poziomie',
	Split: 'Podziel',
	Merge: 'Scal',
	'Add column': 'Dodaj kolumnę',
	'Add row': 'Dodaj wiersz',
	Border: 'Obramowanie',
	'Embed code': 'Wstaw kod',
	Update: 'Aktualizuj',
	superscript: 'indeks górny',
	subscript: 'index dolny',
	'Cut selection': 'Wytnij zaznaczenie',
	Paste: 'Wklej',
	'Choose Content to Paste': 'Wybierz zawartość do wklejenia',
	'Chars: %d': 'Znaki: %d',
	'Words: %d': 'Słowa: %d',
	All: 'Wszystko',
	'Select %s': 'Wybierz: %s',
	'Select all': 'Wybierz wszystko',
	source: 'HTML',
	bold: 'pogrubienie',
	italic: 'kursywa',
	brush: 'pędzel',
	link: 'link',
	undo: 'cofnij',
	redo: 'ponów',
	table: 'tabela',
	image: 'grafika',
	eraser: 'wyczyść',
	paragraph: 'akapit',
	fontsize: 'rozmiar czcionki',
	video: 'wideo',
	font: 'czcionka',
	about: 'O programie',
	print: 'drukuj',
	underline: 'podkreślenie',
	strikethrough: 'przekreślenie',
	indent: 'wcięcie',
	outdent: 'wycięcie',
	fullsize: 'pełen rozmiar',
	shrink: 'przytnij',
	hr: 'linia pozioma',
	ul: 'lista',
	ol: 'lista numerowana',
	cut: 'wytnij',
	selectall: 'zaznacz wszystko',
	'Open link': 'otwórz link',
	'Edit link': 'edytuj link',
	'No follow': 'Atrybut no-follow',
	Unlink: 'Usuń link',
	Eye: 'szukaj',
	pencil: 'edytuj',
	' URL': 'URL',
	Reset: 'wyczyść',
	Save: 'zapisz',
	'Save as ...': 'zapisz jako',
	Resize: 'Zmień rozmiar',
	Crop: 'Przytnij',
	Width: 'Szerokość',
	Height: 'Wysokość',
	'Keep Aspect Ratio': 'Zachowaj proporcje',
	Yes: 'Tak',
	No: 'Nie',
	Remove: 'Usuń',
	Select: 'Wybierz',
	'You can only edit your own images. Download this image on the host?':
		'Możesz edytować tylko swoje grafiki. Czy chcesz pobrać tą grafikę?',
	'The image has been successfully uploaded to the host!':
		'Grafika została pomyślnienie dodana na serwer',
	palette: 'Paleta',
	'There are no files': 'Brak plików.',
	Rename: 'zmień nazwę',
	'Enter new name': 'Wprowadź nową nazwę',
	preview: 'podgląd',
	download: 'pobierz',
	'Paste from clipboard': 'Wklej ze schowka',
	"Your browser doesn't support direct access to the clipboard.":
		'Twoja przeglądarka nie obsługuje schowka',
	'Copy selection': 'Kopiuj zaznaczenie',
	copy: 'kopiuj',
	'Border radius': 'Zaokrąglenie krawędzi',
	'Show all': 'Pokaż wszystkie',
	Apply: 'Zastosuj',
	'Please fill out this field': 'Proszę wypełnić to pole',
	'Please enter a web address': 'Proszę, wpisz adres sieci web',
	Default: 'Domyślnie',
	Circle: 'Koło',
	Dot: 'Punkt',
	Quadrate: 'Kwadrat',
	Find: 'Znaleźć',
	'Find Previous': 'Znaleźć Poprzednie',
	'Find Next': 'Znajdź Dalej',
	'Insert className': 'Wstaw nazwę zajęć',
	'Press Alt for custom resizing': 'Naciśnij Alt, aby zmienić rozmiar'
};
